import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { UserProvider } from './contexts/UserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const isDev = process.env.NODE_ENV === 'development';

const AppTree = (
  <UserProvider>
    <App />
  </UserProvider>
);

root.render(
  isDev ? (
    <React.StrictMode>
      {AppTree}
    </React.StrictMode>
  ) : (
    AppTree
  )
);